"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLoaderTextWrapper = exports.StyledLoaderText = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
var types_1 = require("../../utils/types");
var LoaderTextFadeInOut = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n0% {\n  opacity: 0;\n}\n10% {\n  opacity: 1;\n}\n90% {\n  opacity: 1;\n}\n100% {\n  opacity: 0;\n}\n"], ["\n0% {\n  opacity: 0;\n}\n10% {\n  opacity: 1;\n}\n90% {\n  opacity: 1;\n}\n100% {\n  opacity: 0;\n}\n"])));
var LoaderTextFadeIn = styled_components_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n0% {\n  opacity: 0;\n}\n10% {\n  opacity: 1;\n}\n100% {\n  opacity: 10;\n}\n"], ["\n0% {\n  opacity: 0;\n}\n10% {\n  opacity: 1;\n}\n100% {\n  opacity: 10;\n}\n"])));
var getLoaderTextStyles = function (theme) {
    var _a;
    var loaderTextColors = (_a = {},
        _a[types_1.LIGHT] = {
            color: theme_1.colors.grey7
        },
        _a[types_1.DARK] = {
            color: theme_1.colors.white
        },
        _a);
    return loaderTextColors[theme];
};
exports.StyledLoaderText = styled_components_1.default.div(__assign(__assign({}, theme_1.font), { animationFillMode: 'forwards', left: '0px', opacity: 0, position: 'absolute', right: '0px', textAlign: 'center' }), function (_a) {
    var pauseDuration = _a.pauseDuration, theme = _a.theme, index = _a.index;
    return ({
        animationDelay: (pauseDuration ? pauseDuration * index : 0) + "s",
        animationDuration: pauseDuration + "s",
        color: getLoaderTextStyles(theme).color
    });
});
exports.StyledLoaderTextWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  min-height: ", ";\n  ", ":not(:last-child) {\n    animation-name: ", ";\n  }\n  ", ":last-child {\n    animation-name: ", ";\n  }\n"], ["\n  position: relative;\n  min-height: ", ";\n  ", ":not(:last-child) {\n    animation-name: ", ";\n  }\n  ", ":last-child {\n    animation-name: ", ";\n  }\n"])), theme_1.scaffolding.md, exports.StyledLoaderText, LoaderTextFadeInOut, exports.StyledLoaderText, LoaderTextFadeIn);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map